import { FC, ReactNode } from 'react';

import { WithStyles, withStyles } from '@core/theme/utils/with-styles';
import { useIntercom } from '@shared/hooks/intercom';

import { styles } from './SideNavigationIntercomAction.styles';

export interface SideNavigationIntercomActionProps extends WithStyles<typeof styles> {
  label: string;
  startIcon: ReactNode;
}

const SideNavigationIntercomActionComponent: FC<SideNavigationIntercomActionProps> = ({
  classes,
  label,
  startIcon,
}) => {
  const intercom = useIntercom();

  return (
    <div className={classes.root} onClick={() => intercom.show()}>
      <span className={classes.icon}>{startIcon}</span>
      <span className={classes.actionLabel}>{label}</span>
    </div>
  );
};
export const SideNavigationIntercomAction = withStyles(styles)(SideNavigationIntercomActionComponent);
